import {NewTableDef} from 'app/shared/tables/table-column-def';

export class CurrentAssortmentListModel {
    categoryId: number;
    categoryName: string;

    public static tableInfo(): NewTableDef {
        return {
            tableId: 'CurrentAssortmentList',
            columns: [
                {columnDef: 'Id', type: 'number'},
                {
                    field: 'categoryName',
                    columnDef: 'categoryName',
                    sortColumnDef: 'CategoryNameLevel1',
                    header: 'Kategoria',
                    tooltipEnabled: true,
                    isGeneralSearchColumn: true,
                    filterValue: 'Categories',
                },
            ]
        };
    }
}
